<div class="mx-auto my-6 featured-carousel-wrap overflow-hidden">
  <owl-carousel-o [options]="carouselOptions">
    <ng-template carouselSlide *ngFor="let card of cardData">
      <div class="carousel-item-shell px-1 sm:px-2">
        <div class="game-card relative overflow-hidden rounded-[24px] bg-gradient-to-br {{ card.gradient }}">
          <!-- Decorative circles -->
          <div class="absolute inset-0 pointer-events-none">
            <div class="orb orb-1"></div>
            <div class="orb orb-2"></div>
          </div>

          <!-- Hot badge -->
          <div *ngIf="card.hot"
            class="absolute top-3 right-3 z-20 bg-red-600 text-white text-[10px] sm:text-xs font-bold px-2 sm:px-3 py-1 rounded-full shadow-md">
            {{ card.hot }}
          </div>

          <!-- Content -->
          <div class="relative z-10 card-content">
            <!-- Left content -->
            <div class="card-text">
              <div class="text-block">
                <h4 class="card-title">
                  {{ card.title }}
                </h4>
                <p class="card-description">
                  {{ card.description }}
                </p>
              </div>

              <button class="play-btn --button" (click)="$event.stopPropagation(); openModule(card.route, $event)">
                Play Now
              </button>
            </div>

            <!-- Right image -->
            <div class="card-image-wrap">
              <img [src]="card.imageSrc" [alt]="card.title" class="card-image" />
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </owl-carousel-o>
</div>